function displayQuestionNumber(pageNumber, isEnabled) {
  return isEnabled ? pageNumber : '';
}

export default displayQuestionNumber;
